module.exports = __webpack_public_path__ + "static/media/assidu (2).88ecacc5.svg";